// @flow
import React from 'react';
import cx from 'classnames';

import Quotepone from '../Quotepone/Quotepone';
import GrayBox from "../GrayBox";
import GrayBoxes from "../GrayBoxes";

type Props = {
  oneColumn?: boolean,
};

const FakeQuoteCard = ({ oneColumn }: Props) => (
  <Quotepone duration={100}>
    <div className={cx('QuoteCard FakeQuoteCard', { 'one-column': oneColumn })}>
      <div className="card-content">
        <div className="content-head">
          <h3 className="customer-name">
            <GrayBox min={4} max={8} />
          </h3>
          <div className="description">
            <GrayBoxes countMin={3} countMax={5} sizeMin={3} sizeMax={4} />
          </div>
        </div>
      </div>
    </div>
  </Quotepone>
);

FakeQuoteCard.defaultProps = {
  oneColumn: false,
};

export default FakeQuoteCard;



// WEBPACK FOOTER //
// ./src/components/common/FakeQuoteCard/FakeQuoteCard.js